import { useState, useEffect, useCallback } from 'react';

let timeout;

const Timer = ({ time, onComplete, onUpdate, running }) => {
    const [timeLeft, setTimeLeft] = useState(time);

    useEffect(() => {
        setTimeLeft(time);
    }, [time]);

    useEffect(() => {
        scheduleTimer();

        return () => {
            window.clearTimeout(timeout);
        };
    }, []);

    useEffect(() => {
        if (!running) {
            window.clearTimeout(timeout);
        }
    }, [running]);

    useEffect(() => {
        if (timeLeft === 0 && onComplete) {
            onComplete();
        }

        if (onUpdate) {
            onUpdate(timeLeft);
        }
    }, [timeLeft]);

    const scheduleTimer = () => {
        timeout = setTimeout(timer, 1000);
    };

    const timer = useCallback(() => {
        setTimeLeft(timeLeft => timeLeft - 1);
        scheduleTimer();
    }, [timeLeft]);

    return (
        <div
            className="w-24 h-24 lg:w-40 lg:h-40 rounded-full flex items-center justify-center flex-col text-white border-progress"
            style={{
                '--p': (timeLeft / time * 100),
            }}
        >
            <div className="text-xl lg:text-6xl font-bold nobblee-bold">
                {timeLeft}
            </div>

            <div className="uppercase text-app-green text-xs lg:text-lg text-center">
                Seconds <br />
                Left
            </div>
        </div>
    );
};

export default Timer;
